<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" @click="dialogVisible = true">报名二维码</el-button>
        <el-button type="primary" v-if="hasExport" @click="onDownExcel">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="" prop="companyName">
          <el-input placeholder="请输入公司名称" v-model="searchForm.companyName" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="180" label="公司名称" prop="companyName"></el-table-column>
        <el-table-column min-width="180" label="企业统一信用代码" prop="businessLicense"></el-table-column>
        <el-table-column min-width="120" label="法人姓名" prop="legalName"></el-table-column>
        <el-table-column min-width="180" label="法人身份证号码" prop="legalId"></el-table-column>
        <el-table-column min-width="180" label="银行开户行" prop="bankAccount"></el-table-column>
        <el-table-column min-width="180" label="银行开户账号" prop="bankNum"></el-table-column>
        <el-table-column min-width="120" label="联系人" prop="contactPerson"></el-table-column>
        <el-table-column min-width="120" label="联系人号码" prop="contactNumber"></el-table-column>
        <el-table-column min-width="120" label="审批状态">
          <template v-slot="{ row }">
            <el-tag v-if="row.companyState == '1'">待审批</el-tag>
            <el-tag v-if="row.companyState == '2'" type="success">已通过</el-tag>
            <el-tag v-if="row.companyState == '3'" type="danger">已拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="当前节点" prop="nodeName"></el-table-column>
        <el-table-column width="200" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="
              $router.push('/supplier/detail?companyId=' + row.companyId)
              ">详情</el-button>
            <el-button type="text" v-if="row.nodeRole === userInfo.roleId" @click="
              $router.push('/supplier/detail?companyId=' + row.companyId + '&isApproval=1')
              ">审批</el-button>
            <el-button type="text" v-if="hasEdit" @click="
              $router.push('/supplier/edit?companyId=' + row.companyId)
              ">编辑</el-button>
            <el-button type="text" class="del-btn" @click="onDelete(row.companyId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <el-dialog :visible.sync="dialogVisible" title="二维码" width="500px">
      <el-image style="width: 100%;"
        src="https://dcs.jscjly.com//group1/default/20250516/61C6CAE977134BEDB994B531E20068E4.jpg"></el-image>
    </el-dialog>

    <!-- 审批 -->
    <!-- <ApprovalDialog
      urlType="3"
      :relatedId="rowId"
      v-if="showDlg"
      @closeDlg="showDlg = false"
      @successSave="loadData"
      :showDlg="showDlg"
    ></ApprovalDialog> -->

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { downloadExcelFile } from '@/utils/globalMethods'
export default {
  name: 'Supplier',
  mixins: [keepAlive],
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        companyName: ''
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDelete() {
      return this.buttonList.includes('hasDelete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    getFilenameFromHeader(contentDisposition) {
      if (!contentDisposition) return null

      // 匹配filename或filename*参数（优先后者）
      const regex = /filename\*?=((['"]).*?\2|[^;\n]*)/
      const matches = regex.exec(contentDisposition)

      if (matches && matches[1]) {
        let filename = matches[1].replace(/['"]/g, '') // 去除引号
        // 处理编码（如utf-8''前缀）
        if (filename.startsWith("utf-8''")) {
          filename = decodeURIComponent(filename.substring(7))
        }
        return filename
      }
      return null
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios.post(this.$apis.supplier.exportYcCompanyInfo, {
        ...this.searchForm
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          console.log('ressss', res)
          const filename = this.getFilenameFromHeader(res.headers['content-disposition'])
          downloadExcelFile(res.data, filename)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.supplier.selectYcCompanyInfoByPage, this.searchForm).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    },
    onDelete(companyId) {
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios
          .post(this.$apis.supplier.deleteYcCompanyInfo, {
            companyId
          })
          .then(() => {
            this.loadData()
          })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
